import { render, staticRenderFns } from "./attorneydocumentupload.vue?vue&type=template&id=da574602&scoped=true&"
import script from "./attorneydocumentupload.vue?vue&type=script&lang=js&"
export * from "./attorneydocumentupload.vue?vue&type=script&lang=js&"
import style0 from "./attorneydocumentupload.vue?vue&type=style&index=0&id=da574602&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da574602",
  null
  
)

export default component.exports